import { Injectable } from '@angular/core';
import { catchAndContinue, filterUndefined } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { MouldLogDataService } from 'src/app/services';
import { EquipmentFacadeService } from 'src/app/services/equipment-facade.service';
import { handleError } from 'src/app/state/akita-error-helper';
import { CollectionState } from 'src/app/state/collection-state';
import { MouldLogEntry } from 'src/app/models/domain';

@Injectable({ providedIn: 'root' })
export class MouldLogOverviewService {
  private readonly state = new CollectionState<MouldLogEntry>();

  public readonly mouldLogEntries$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(
    private readonly mouldLogDataService: MouldLogDataService,
    private readonly equipmentFacade: EquipmentFacadeService
  ) {}

  public loadMouldLogByEquipmentNumber(): Observable<void> {
    return this.equipmentFacade.selectedEquipmentId$.pipe(
      filterUndefined(),
      tap(() => {
        this.state.setLoading(true);
      }),
      switchMap((equipmentNumber) =>
        catchAndContinue(
          this.mouldLogDataService.loadMouldLogPage({ page: 1, perPage: 1000 }, equipmentNumber),
          (error) => {
            handleError(this.state, error);
          }
        )
      ),
      tap((response) => {
        this.state.set(response.data);
      }),
      map(() => undefined)
    );
  }
}
